var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 19,
    viewBox: "0 0 34 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26677 0.347811C3.75254 -0.115937 4.54014 -0.115937 5.02591 0.347811L9.09514 4.23253C11.4566 3.04631 14.1462 2.375 17 2.375C19.8538 2.375 22.5434 3.04631 24.9049 4.23253L28.9741 0.347811C29.4599 -0.115937 30.2475 -0.115937 30.7332 0.347811C31.219 0.811558 31.219 1.56344 30.7332 2.02719L27.0682 5.52606C31.2722 8.48062 34 13.2383 34 18.6042C34 18.7365 33.9983 18.8684 33.995 19H0.00495753C0.00165877 18.8684 0 18.7365 0 18.6042C0 13.2383 2.72782 8.48062 6.93183 5.52606L3.26677 2.02719C2.781 1.56344 2.781 0.811558 3.26677 0.347811ZM10.3659 13.4583C11.2818 13.4583 12.0244 12.7494 12.0244 11.875C12.0244 11.0005 11.2818 10.2917 10.3659 10.2917C9.44987 10.2917 8.70732 11.0005 8.70732 11.875C8.70732 12.7494 9.44987 13.4583 10.3659 13.4583ZM25.2927 11.875C25.2927 12.7494 24.5501 13.4583 23.6341 13.4583C22.7182 13.4583 21.9756 12.7494 21.9756 11.875C21.9756 11.0005 22.7182 10.2917 23.6341 10.2917C24.5501 10.2917 25.2927 11.0005 25.2927 11.875Z",
    fill: "#726FB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/AndroidIcon.509fb38371be3821673fcdd463a19708.svg";
export { ForwardRef as ReactComponent };